import {
    AfterViewInit,
    Component,
    ElementRef,
    OnInit,
    ViewChild,
} from '@angular/core';
import { ContactService, Contact } from '../../../_services';
import { ContactNamePipe } from '../../_shared/contact-name.pipe';
import { ContactActivePipe } from '../../_shared/contact-deleted.pipe';

@Component({
    selector: 'jhi-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['contact.component.scss'],
    providers: [ContactNamePipe, ContactActivePipe],
})
export class ContactComponent implements OnInit, AfterViewInit {
    private static _search: string = '';

    @ViewChild('searchInput')
    private searchInput: ElementRef;

    account: any;
    error: string;
    success: string;
    contacts: Array<Contact> = [];
    displayRemovedContacts: boolean = false;

    constructor(private contactService: ContactService) {}

    get search(): string {
        return ContactComponent._search;
    }

    set search(search: string) {
        ContactComponent._search = search;
    }

    ngOnInit() {
        this.getAllContacts();
    }

    ngAfterViewInit(): void {
        this.searchInput.nativeElement.focus();
    }

    getAllContacts() {
        this.contactService.getAllContacts().subscribe((contacts) => {
            this.contacts = contacts;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/directory/contact/contact.component.ts